import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./Font/Poppins-Black.ttf";
import "./Font/Poppins-Bold.ttf";
import "./Font/Poppins-ExtraBold.ttf";
import "./Font/Poppins-SemiBold.ttf";
import "./Font/Poppins-Regular.ttf";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
